<template>
  <b-row>
    <b-col v-if="!loading" cols="12" lg="12">
      <b-row>
        <b-col md="9">
          <b-row>
            <b-col>
              <b-card no-header>
                <template #header>
                  <b-row no-gutters align-content="between">
                    <b-col>Informações</b-col>
                    <b-col v-if="dsar.protocolLastView" class="text-right"
                      >Última Visualização:
                      {{ dsar.protocolLastView | datetime }} | Total:
                      {{ dsar.protocolViewCount }}
                    </b-col>
                  </b-row>
                </template>
                <b-card-body>
                  <fieldset class="pb-3">
                    <legend hidden>Inforamções da Demanda</legend>
                    <b-row>
                      <b-col cols="6">
                        <h5>
                          Protocolo: <strong>{{ dsar.protocol }}</strong>
                        </h5>
                        <h5>
                          Data de Recebimento: {{ dsar.createdAt | datetime }}
                        </h5>
                        <h5>Portal de Recebimento: /{{ dsar.portal.slug }}</h5>
                        <h5>Prazo: {{ getDeadline(dsar) | datetime }}</h5>
                      </b-col>
                      <b-col>
                        <h5>
                          Status:
                          <b-badge :variant="getBadgeColor(dsar.status)"
                            >{{ getStatusText(dsar.status) }}
                          </b-badge>
                        </h5>
                        <h5>
                          Última Movimentação: {{ dsar.updatedAt | datetime }}
                        </h5>
                      </b-col>
                    </b-row>
                  </fieldset>
                  <fieldset class="pb-3">
                    <legend>Requerente</legend>
                    <b-row>
                      <b-col cols="4">
                        <label>Nome:</label>
                        {{ dsar.person.fullName | noInformation }}
                      </b-col>
                      <b-col cols="4">
                        <label>CPF:</label>
                        {{ dsar.person.cpf | noInformation }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="4">
                        <label>Telefone:</label>
                        {{ dsar.person.phone | noInformation }}
                      </b-col>
                      <b-col cols="4">
                        <label>Email:</label>
                        {{ dsar.person.email | noInformation }}
                      </b-col>
                    </b-row>
                  </fieldset>
                  <b-row class="pb-3">
                    <b-col md="12">
                      <h5>Descrição</h5>
                      <div>{{ dsar.text }}</div>
                    </b-col>
                  </b-row>
                  <b-button
                    variant="link"
                    class="float-right"
                    @click="fullView = !fullView"
                  >
                    <template v-if="fullView"
                      >Comprimir <i class="fas fa-minus" aria-hidden="true"></i
                    ></template>
                    <template v-else
                      >Expandir <i class="fas fa-plus" aria-hidden="true"></i
                    ></template>
                  </b-button>
                  <b-collapse id="dsar-info" v-model="fullView">
                    <b-row v-if="dsar.files.length > 0">
                      <b-col md="12">
                        <h5>Anexos</h5>
                        <b-list-group>
                          <b-list-group-item
                            v-for="(file, idx) in dsar.files"
                            :key="idx"
                            class="d-flex justify-content-between align-items-center"
                          >
                            {{ file.name }}
                            <b-button @click="downloadFile(file)"
                              ><i class="fa fa-download" aria-hidden="true"></i>
                            </b-button>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                    </b-row>
                  </b-collapse>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card no-header>
                <template #header>
                  Processamento - Informaçoes Internas
                  <b-button
                    v-if="canEdit"
                    :disabled="loadingEvents"
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="$refs.eventModal.show()"
                    >Adicionar Movimentação
                  </b-button>
                </template>
                <em v-if="loadingEvents">Carregando...</em>
                <b-card
                  v-for="event in events"
                  v-else
                  :id="`event-${event._id}`"
                  :key="event._id"
                  no-header
                >
                  <div>#{{ event.number }}</div>
                  <label><strong>Tipo:</strong></label>
                  {{ labelEventType(event.type) }}
                  <br />
                  <label
                    v-if="event.type === DSAREventType.STATUS_CHANGE"
                    class="card-text"
                  >
                    <strong>Novo Status: </strong>
                    <b-badge :variant="getBadgeColor(event.status)">{{
                      getStatusText(event.status)
                    }}</b-badge>
                  </label>
                  <template
                    v-if="
                      event.type === DSAREventType.STATUS_CHANGE &&
                      event.status === DSARStatus.CONCLUDED
                    "
                  >
                    <br />
                    <label class="card-text">
                      <strong>Classificação: </strong>
                      {{ classificationMaps.dsarClosure[event.dsarClosure] }}
                    </label>
                  </template>
                  <br />
                  <p
                    v-if="
                      event.type !==
                        DSAREventType.MONITORING_RESPONSE_ENABLED &&
                      event.type !== DSAREventType.MONITORING_RESPONSE_DISABLED
                    "
                    class="card-text"
                  >
                    <label><strong>Descrição:</strong></label>
                    {{ event.description }}
                  </p>
                  <template v-if="event.type === DSAREventType.WITH_ATTACHMENT">
                    <b-list-group v-if="event.files && event.files.length > 0">
                      <b-list-group-item
                        v-for="(file, idx) in event.files"
                        :key="idx"
                        class="d-flex justify-content-between align-items-center"
                      >
                        {{ file.name }}
                        <b-button
                          variant="link"
                          :href="`/api/dsar/${event.dsar}/events/${event._id}/file/${file._id}`"
                          target="_blank"
                        >
                          <i class="fa fa-download" aria-hidden="true"></i>
                          Download
                        </b-button>
                      </b-list-group-item>
                    </b-list-group>
                    <b-alert v-else show variant="warning"
                      >Arquivo não recebido!</b-alert
                    >
                  </template>
                  <b-row
                    v-if="event.pendency && event.pendency.user"
                    :class="{ 'text-danger': !event.pendency.resolvedBy }"
                    class="mb-1 font-italic"
                  >
                    <b-col cols="12">
                      <label
                        ><strong>Pendência para: </strong>
                        <template v-if="companyUsers[event.pendency.user]">
                          {{ companyUsers[event.pendency.user].name }}
                          {{ companyUsers[event.pendency.user].surname }}
                        </template>
                        <template v-else>
                          <i class="fa fa-user-tie" aria-hidden="true"></i>
                          {{ managedByCompanyUsers[event.pendency.user].name }}
                          {{
                            managedByCompanyUsers[event.pendency.user].surname
                          }}
                        </template>
                      </label>
                      <br />
                      <label v-if="event.pendency.dueDate">
                        <strong>Prazo: </strong
                        >{{ event.pendency.dueDate | date }}
                      </label>
                      <br />
                      <b-button
                        v-if="!event.pendency.resolvedBy && canEdit"
                        variant="outline-danger"
                        size="sm"
                        @click="resolvePendency(event)"
                        >Resolver
                      </b-button>
                      <label v-else-if="canEdit"
                        >Resolvida pela movimentação
                        <b-button
                          variant="link"
                          class="p-0 pb-1"
                          @click="showEvent(event.pendency.resolvedBy)"
                        >
                          #{{ getEventNumber(event.pendency.resolvedBy) }}
                        </b-button>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="event.pendency && event.pendency.resolves"
                    class="mb-1 font-italic"
                  >
                    <b-col cols="12">
                      <label
                        >Resolve a pendência da movimentação
                        <b-button
                          variant="link"
                          class="p-0 pb-1 font-italic"
                          @click="showEvent(event.pendency.resolves)"
                        >
                          #{{ getEventNumber(event.pendency.resolves) }}
                        </b-button>
                      </label>
                    </b-col>
                  </b-row>
                  <p class="card-text">
                    <small class="text-muted">
                      <i class="fa fa-calendar-alt" aria-hidden="true"></i>
                      {{ event.createdAt | datetime }} -
                      <template v-if="companyUsers[event.user]">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        {{ companyUsers[event.user].name }}
                        {{ companyUsers[event.user].surname }}
                      </template>
                      <template v-else-if="managedByCompanyUsers[event.user]">
                        <i class="fa fa-user-tie" aria-hidden="true"></i>
                        {{ managedByCompanyUsers[event.user].name }}
                        {{ managedByCompanyUsers[event.user].surname }}
                      </template>
                      <template v-else>
                        <i
                          class="fa fa-user-tie text-info"
                          aria-hidden="true"
                        ></i>
                        {{ conformitaUsers[event.user].name }}
                        {{ conformitaUsers[event.user].surname }}
                      </template>
                    </small>
                  </p>
                </b-card>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="3">
          <b-row>
            <b-col>
              <b-card no-header>
                <template #header>
                  <b-row class="mb-1">
                    <b-col cols="8">Acompanhamento Externo</b-col>
                    <b-col v-if="canEdit">
                      <b-button
                        :disabled="loadingMonitorings"
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="$refs.monitoringModal.show()"
                        >Inserir
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-if="canEdit">
                    <b-col>
                      <b-button
                        :disabled="loadingMonitorings"
                        variant="secondary"
                        size="sm"
                        class="float-right"
                        @click="toggleMonitoringResponse(dsar)"
                      >
                        <template v-if="dsar.monitoringResponseEnabled">
                          Desabilitar Resposta
                        </template>
                        <template v-else> Habilitar Resposta </template>
                      </b-button>
                    </b-col>
                  </b-row>
                </template>
                <b-card
                  v-for="monitoring in monitorings"
                  :key="monitoring._id"
                  :class="{ 'text-secondary': monitoring.hidden }"
                >
                  <p class="card-text">
                    <b-row>
                      <b-col>
                        <i class="fa fa-calendar-alt" aria-hidden="true" />
                        {{ monitoring.createdAt | datetime }}
                      </b-col>
                      <b-col
                        v-if="monitoring.type !== DSARMonitoringType.RESPONSE"
                        cols="*"
                      >
                        <b-button
                          v-if="canEdit"
                          size="sm"
                          variant="link"
                          class="text-dark"
                          :title="monitoring.hidden ? 'Exibir' : 'Ocultar'"
                          @click="toggleMonitoringVisibility(monitoring)"
                        >
                          <i
                            class="fa"
                            :class="{
                              'fa-eye': !monitoring.hidden,
                              'fa-eye-slash': monitoring.hidden,
                            }"
                            aria-hidden="true"
                          />
                        </b-button>
                      </b-col>
                    </b-row>
                    <template
                      v-if="monitoring.type !== DSARMonitoringType.RESPONSE"
                    >
                      <template v-if="companyUsers[monitoring.user]">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        {{ companyUsers[monitoring.user].name }}
                        {{ companyUsers[monitoring.user].surname }}
                      </template>
                      <template
                        v-else-if="managedByCompanyUsers[monitoring.user]"
                      >
                        <i class="fa fa-user-tie" aria-hidden="true"></i>
                        {{ managedByCompanyUsers[monitoring.user].name }}
                        {{ managedByCompanyUsers[monitoring.user].surname }}
                      </template>
                      <template v-else>
                        <i
                          class="fa fa-user-tie text-info"
                          aria-hidden="true"
                        ></i>
                        {{ conformitaUsers[monitoring.user].name }}
                        {{ conformitaUsers[monitoring.user].surname }}
                      </template>
                    </template>
                  </p>
                  <p
                    v-if="monitoring.type === DSARMonitoringType.COMPANY"
                    class="card-text"
                  >
                    {{ monitoring.description }}
                  </p>
                  <p
                    v-else-if="monitoring.type === DSARMonitoringType.RESPONSE"
                    class="card-text text-info"
                  >
                    <i class="fas fa-reply" aria-hidden="true" />
                    {{ monitoring.response.text }}
                  </p>
                </b-card>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card no-header>
                <template #header>
                  Classificação
                  <b-button
                    v-if="canEdit"
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="$refs.classificationModal.show()"
                    >Editar
                  </b-button>
                </template>
                <template v-if="dsar.classification">
                  <ClassificationViewer
                    :record="dsar"
                    classification="receivingMeans"
                    label="Meio de Recebimento"
                  />
                  <ClassificationViewer
                    :record="dsar"
                    classification="dsarRequirementType"
                    label="Tipo de Requisição"
                  />
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <dsar-event-modal
        ref="eventModal"
        :dsar="dsar"
        :pendency="pendencyEvent"
        @new-event="loadEvents"
        @status-changed="onStatusChanged"
        @cancel="pendencyEvent = null"
      ></dsar-event-modal>
      <dsar-monitoring-modal
        ref="monitoringModal"
        :dsar="dsar"
        @new-monitoring="loadMonitoring"
      ></dsar-monitoring-modal>
      <classification-modal
        ref="classificationModal"
        :dsar="dsar"
        @classification-changed="onClassificationChanged"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  getDSAR,
  getDSAREvents,
  getDSARMonitoring,
  setDSARMonitoringVisibility,
  setDSARMonitoringResponseEnabled,
} from "../../api/dsar";
import { getSystemUsers } from "../../api/user";
import { getCompanyUsers } from "../../api/company";
import {
  getBadgeColor,
  getStatusText,
  labelEventType,
} from "../complaints/utils";
import { mapGetters } from "vuex";
import DSAREventType from "../../../../backend/models/dsar/DSAREventType.ts";
import DSARMonitoringType from "../../../../backend/models/dsar/DSARMonitoringType.ts";
import DSARStatus from "../../../../backend/models/dsar/DSARStatus.ts";
import { getDeadline } from "./dsar-utils";

import { mask } from "vue-the-mask";
import DsarEventModal from "./dsar-event-modal";
import DsarMonitoringModal from "./dsar-monitoring-modal";
import ClassificationModal from "../complaints/classification-modal";
import ClassificationViewer from "@/views/commons/ClassificationViewer";

export default {
  name: "DSAR",
  components: {
    ClassificationViewer,
    ClassificationModal,
    DsarEventModal,
    DsarMonitoringModal,
  },
  directives: { mask },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      DSAREventType,
      DSARStatus,
      DSARMonitoringType,
      loading: false,
      fullView: false,
      dsar: {},
      companyUsers: {},
      managedByCompanyUsers: {},
      conformitaUsers: {},
      loadingEvents: false,
      events: [],
      phoneServiceProtocol: null,
      oldPhoneServiceProtocol: null,
      loadingMonitorings: false,
      monitorings: [],
      loadingDenounceds: false,
      pendencyEvent: null,
      denounceds: [],
    };
  },
  computed: {
    ...mapGetters(["profile", "classificationMaps", "permissions"]),
    masterUser() {
      const role = this.profile.role;
      return role === "root" || role === "company-root";
    },
    conformitaUser() {
      return !!this.conformitaUsers[this.profile._id];
    },
    canEdit() {
      if (parseInt(this.profile.role) === this.profile.role) {
        return (
          (this.permissions.dsar && this.permissions.dsar.edit) ||
          this.permissions.dsar.create
        );
      }
      return true;
    },
  },
  async created() {
    this.loading = true;
    const response = await getDSAR(this.id);
    const dsar = response.data;
    this.dsar = dsar;

    let resp = await getCompanyUsers(dsar.company._id, true);
    this.companyUsers = resp.data.reduce((obj, user) => {
      obj[user["_id"]] = user;
      return obj;
    }, {});

    if (dsar.company.managedBy) {
      let managedCompanyUsers = (
        await getCompanyUsers(dsar.company.managedBy, true)
      ).data;
      this.managedByCompanyUsers = managedCompanyUsers.reduce((obj, user) => {
        obj[user["_id"]] = user;
        return obj;
      }, {});
    }

    resp = await getSystemUsers();
    this.conformitaUsers = resp.data.reduce((obj, user) => {
      obj[user["_id"]] = user;
      return obj;
    }, {});

    this.loadMonitoring();
    this.loadClassifications();

    await this.loadEvents();
    const { event } = this.$route.query;
    if (event) {
      let query = Object.assign({}, this.$route.query);
      delete query.event;
      this.$router.replace({ query });
      const showQueryEvent = () => {
        const element = document.getElementById(`event-${event}`);
        if (!element) {
          this.$nextTick(showQueryEvent);
        }
        this.showEvent(event);
      };
      this.$nextTick(showQueryEvent);
    }

    this.loading = false;
  },
  methods: {
    getStatusText,
    getBadgeColor,
    labelEventType,
    getDeadline,

    showEvent(id) {
      const element = document.getElementById(`event-${id}`);
      const offset = 55;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
    getEventNumber(id) {
      return this.events.find((e) => e._id === id).number;
    },
    goBack() {
      this.$router.go(-1);
    },

    resolvePendency(event) {
      this.pendencyEvent = event;
      this.$refs.eventModal.show();
    },

    async loadEvents() {
      this.pendencyEvent = null;
      this.loadingEvents = true;

      const response = await getDSAREvents(this.dsar._id);
      this.events = response.data;
      this.loadingEvents = false;
    },

    async loadMonitoring() {
      this.loadingMonitorings = true;

      const response = await getDSARMonitoring(this.dsar._id);
      this.monitorings = response.data;
      this.loadingMonitorings = false;
    },

    downloadFile(file) {
      const link = `${window.location.origin}/api/dsar/${this.dsar._id}/files/${file._id}`;
      const a = document.createElement("a");
      a.setAttribute("download", "");
      a.setAttribute("href", link);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    onClassificationChanged(classification) {
      this.$set(this.dsar, "classification", classification);
    },

    onStatusChanged(status) {
      this.dsar.status = status;
    },

    async toggleMonitoringVisibility(monitoring) {
      try {
        await setDSARMonitoringVisibility(monitoring, !monitoring.hidden);
        monitoring.hidden = !monitoring.hidden;
        this.$bvToast.toast(
          `Acompanhamento ${
            monitoring.hidden ? "ocultado" : "exibido"
          } com sucesso!`,
          {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
          }
        );
        this.$forceUpdate();
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            autoHideDelay: 10000,
            appendToast: true,
            solid: true,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            autoHideDelay: 10000,
            appendToast: true,
            solid: true,
          });
        }
      }
    },

    async toggleMonitoringResponse(dsar) {
      try {
        await setDSARMonitoringResponseEnabled(
          dsar,
          !dsar.monitoringResponseEnabled
        );
        dsar.monitoringResponseEnabled = !dsar.monitoringResponseEnabled;
        this.$bvToast.toast(
          `Resposta ${
            dsar.monitoringResponseEnabled ? "habilitada" : "desabilitada"
          } com sucesso!`,
          {
            title: "Sucesso",
            toastClass: "custom-toast custom-toast-success",
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
          }
        );
        await this.loadEvents();
        this.$forceUpdate();
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            autoHideDelay: 10000,
            appendToast: true,
            solid: true,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            autoHideDelay: 10000,
            appendToast: true,
            solid: true,
          });
        }
      }
    },

    async loadClassifications() {
      this.$store.dispatch(
        "RefreshCompanyClassifications",
        this.dsar.company._id
      );
    },
  },
};
</script>
